import { useOktaAuth } from "@okta/okta-react";

export const LogoutView = () => {
  const { oktaAuth } = useOktaAuth();

  const logout = async () => {
    oktaAuth.tokenManager.clear();
    window.location.replace("/login");
  };

  logout();

  return null;
};
